import { useState, useEffect } from "react"
import { useNavigate, useParams } from "react-router"
import AppLayout from "../../components/layout/AppLayout"
import PostCreateForm from "../../components/post-schedule/PostCreateForm"
import { api } from "../../lib/api"
import { ScheduledPost } from "../../types/scheduled-post"
import { useSelectedAccount } from "../../contexts/AccountContext"
import "../../styles/post-schedule.scss"

const PostCreatePage = () => {
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  const { selectedAccountId, selectedAccountIds, selectedOrganizationId, organizations } = useSelectedAccount()
  const allAccounts = organizations.flatMap(o => o.accounts)

  const [editPost, setEditPost] = useState<ScheduledPost | null>(null)
  const [loadError, setLoadError] = useState(false)

  useEffect(() => {
    if (!id) return
    // set_organization が未指定時に current_user.organizations.first（選択中組織とは限らない）へ
    // フォールバックするため、他の組織スコープ呼び出しと同じく organization_id を明示する
    const params = selectedOrganizationId != null ? `?organization_id=${selectedOrganizationId}` : ""
    api.get<ScheduledPost>(`/scheduled_posts/${id}${params}`)
      .then(setEditPost)
      .catch(() => setLoadError(true))
  }, [id, selectedOrganizationId])

  useEffect(() => {
    if (!editPost) return
    if (selectedAccountIds.length > 0 && !selectedAccountIds.includes(editPost.instagram_account.id)) {
      navigate("/post-schedule")
    }
  }, [selectedAccountIds, editPost, navigate])

  const isEditMode = !!id
  const isLoading  = isEditMode && !editPost && !loadError
  const accountId  = editPost?.instagram_account.id ?? selectedAccountId
  const targetAccount = allAccounts.find(a => a.id === accountId)
  const planLocked = targetAccount != null && !targetAccount.features.scheduled_post

  return (
    <AppLayout pageTitle={isEditMode ? "予約投稿を編集" : "新規予約投稿"} onBack={() => navigate("/post-schedule")}>
      <div className="post-schedule">

        {loadError ? (
          <p style={{ color: "#ef4444" }}>投稿が見つかりませんでした</p>
        ) : isLoading ? (
          <div style={{ textAlign: "center", padding: 40, color: "#9ca3af" }}>
            <span className="spinner" style={{ borderColor: "#e5e7eb", borderTopColor: "#6366f1", width: 24, height: 24 }} />
          </div>
        ) : accountId !== null ? (
          <PostCreateForm
            accounts={allAccounts}
            selectedAccountId={accountId}
            editPost={editPost ?? undefined}
            onSuccess={() => navigate("/post-schedule")}
            onDelete={() => navigate("/post-schedule")}
            disabled={!isEditMode && selectedAccountIds.length > 1}
            planLocked={planLocked}
          />
        ) : (
          <div style={{ textAlign: "center", padding: 40, color: "#9ca3af" }}>
            アカウントが選択されていません。ヘッダーのアカウント選択からアカウントを選んでください。
          </div>
        )}
      </div>
    </AppLayout>
  )
}

export default PostCreatePage
